import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { OrderLineService, CancelOrderLineService } from 'common/data';

class OrderLineStore extends BaseStore {
	constructor(rootStore) {
		super(new OrderLineService(rootStore.app.baasic.apiClient));
		this.cancelOrderLineService = new CancelOrderLineService(rootStore.app.baasic.apiClient);
	}

	@action async findOrderLine(filter) {
		const response = await this.service.find(filter);
		response.data.searchQuery = filter.search;
		this.response = response.data;
		return this.response;
	}

	@action async getOrderLine(id, options) {
		const orderLine = await this.service.get(id, options);
		this.item = orderLine.data;
		return orderLine.data;
	}

	@action async linkAllOrderLines(sourceOfChange) {
		const response = this.service.linkAllOrderLines(sourceOfChange);
		return response;
	}

	@action async linkOrderLine(linkOrderLineParams, sourceOfChange) {
		await this.service.linkOrderLine(linkOrderLineParams, sourceOfChange);
	}

	@action async cancelAmazonOrder(orderId, sourceOfChange) {
		const response = await this.cancelOrderLineService.cancelAmazonOrder(orderId, sourceOfChange);
		return response;
	}
	@action async cancelMiraklOrder(orderId, sourceOfChange) {
		const response = await this.cancelOrderLineService.cancelMiraklOrder(orderId, sourceOfChange);
		return response;
	}

	@action async refundAllOrderLines(orderId, sourceOfChange) {
		const response = await this.cancelOrderLineService.refundAllOrderLines(orderId, sourceOfChange);
		return response;
	}

	@action async refundOrderLine(orderLineId, sourceOfChange) {
		const response = await this.cancelOrderLineService.refundOrderLine(orderLineId, sourceOfChange);
		return response;
	}

	// An empty orderLineIds cancels every line on the order.
	@action async cancelWalmartOrderLines(orderId, orderLineIds, sourceOfChange) {
		const response = await this.cancelOrderLineService.cancelWalmartOrderLines(orderId, orderLineIds, sourceOfChange);
		return response;
	}
}

export default OrderLineStore;
